import sensors from "sa-sdk-javascript"
import Utils from "../../util"

const { ENV } = process.env.ENV_DATA
const IsDevEnv = ["development", "testing"].includes(ENV)
const ProductionUrls = {
    dicos: {
        http: "http://data.belray-coffee.com:8106/sa?project=dicospro",
        https: "https://data.belray-coffee.com:8106/sa?project=dicospro",
    },
    kangchef: {
        http: "http://data.belray-coffee.com:8106/sa?project=kangshifuproduction",
        https: "https://data.belray-coffee.com:8106/sa?project=kangshifuproduction",
    },
    belray: {
        http: "http://data.belray-coffee.com:8106/sa?project=production",
        https: "https://data.belray-coffee.com:8106/sa?project=production",
    },
    testing: {
        http: "http://data.belray-coffee.com:8106/sa?project=default",
        https: "https://data.belray-coffee.com:8106/sa?project=default",
    },
}

const HostKeyWords = ["dicos", "masterkongchef", "belray"]
const HostKeyWordsToKey = {
    dicos: "dicos",
    masterkongchef: "masterkongchef",
    belray: "belray",
}

const UrlParams = Utils.getUrlParam(window.location.href);

const Brand = GetBrandName();
window.channelId = UrlParams.channel_id;

function GetBrandName() {
    const _host = location.host
    let _brand = "";
    HostKeyWords.forEach((words) => {
        if (_host.includes(words)) {
            _brand = HostKeyWordsToKey[words]
        }
    })
    window.brand = _brand;
    return _brand;
}

class GlobalSensors {
    static init() {
        const uploadUrl = this.getUploadUrl()
        sensors.init({
            // 神策系统配置
            server_url: uploadUrl, // 数据接收地址
            use_app_track: true,
            show_log: IsDevEnv, // 控制台显示数据开
            heatmap: { scroll_notice_map: "not_collect" },
            is_track_single_page: true,
            use_client_time: true,
            send_type: "beacon",
        })
    }

    static getUploadUrl() {
        if (IsDevEnv) {
            // 测试环境上报接口
            return ProductionUrls.testing.https
        }
        if (ProductionUrls[Brand]) {
            // 品牌上报接口
            return ProductionUrls[Brand].https
        }
        return ProductionUrls.testing.https // 默认上报接口
    }

    static track(e, obj) {
        try {
            obj.join_brand_name = Brand;
            obj.join_channel_id = UrlParams.channel_id;
            sensors.track(e, obj);
        } catch (e) {
            console.warn("sensors track error", e, obj);
        }
    }
}
GlobalSensors.init()
window.sensors = GlobalSensors
export default GlobalSensors

/*

使用示例：

window.sensors.track("home-view", { params: { name: 'richie do' } });

*/
